<template>
  <div class="mortgage_print_wrapper" v-if="getItem">
    <div class="page page2">
      <h1>動產抵押契約書</h1>
      <p class="p1">立動產抵押契約書人<span class="titall tit1">{{getItem.name}}</span>（以下簡稱抵押物提供人）願提供下開所有動產（以下簡稱抵押物）設定第一順位動 產抵押權予裕富數位資融股份有限公司（以下簡稱債權人），抵押物提供人、債務人及相關當事人特訂立本契約，且均願遵守下列各條款：</p>
      <ul class="ul1">
        <li> <span class="tit">一、</span>本動產抵押契約書登記有效期間：自立約日起至民國<span class="titall tit2">{{getItem.endDate.year}}</span>年<span class="titall tit3">{{getItem.endDate.month}}</span>月<span class="titall tit4">{{getItem.endDate.day}}</span>日止。</li>
        <li> <span class="tit">二、</span>擔保債權：最高限額新臺幣<span class="titall tit5">九萬</span>元整，擔保種類及範圍：債務人對抵押權人現在（包括過去所負現在尚未清償）及將來在本抵押權設定契約書約定最高限額內所負之債務，包括分期付款之本金、利息、遲延利息、違約金、對債務人取得執行名義之費用、強制執行之費用、參與分配之費用、其他經雙方所約定之各項費用（包括但不限於抵押權人垫付擔保物之保險費用）與因債務不履行而發生之損害賠償。<br/>利率：依雙方各個分期付款買賣契約、債權讓與契約等約定利率為準。</li>
        <li> <span class="tit">三、</span>抵押物：其名稱、數量、特別標誌、說明以及占有抵押物者之姓名、名稱、及方式所在地，詳下表：</li>
      </ul>
      <table class="table1">
        <tr>
          <th width="104px">車別</th>
          <th width="103px">牌照號碼</th>
          <th width="103px">規格形式</th>
          <th width="103px">廠牌</th>
          <th width="103px">年份</th>
          <th width="140px">引擎號碼/車身號碼</th>
          <th>備註</th>
        </tr>
        <tr>
          <td>{{getItem.carType}}</td>
          <td>{{getItem.carId}}</td>
          <td>{{getItem.carEngineType}}</td>
          <td>{{getItem.vendorId}}</td>
          <td>{{getItem.carYear}}</td>
          <td>{{getItem.engineId}}</td>
          <td>{{getItem.comment}}</td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td colspan="7" class="tdLast">抵押物存放地址：同債務人地址。</td>
        </tr>
      </table>
      <ul class="ul2">
        <li> <span class="tit">四、</span>本契約書登記有效期間屆滿前，債務人仍未清償全部借款本息或有其他債務不履行之情事時，債權人得於期滿前自行申請延長登記期限；延長設定登記之費用，由抵押物提供人負擔。</li>
        <li> <span class="tit">五、</span>抵押物提供人簽立本契約，應同時提出辦理動產抵押應備之證件及其影本，會同債權人共同向登記機關辦理登記手續，費用由抵押物提供人負擔 。嗣後如有須辦理動產抵押變更之情事，抵押物提供人亦願立即配合辦理變更登記，其費用由抵押物提供人負擔。</li>
        <li> <span class="tit">六、</span>抵押物提供人保證提供擔保之抵押物產權無瑕疵及確係抵押物提供人完全合法所有，無動產擔保交易法施行細則第八條所列各款情形，他人並無任何權利或設定負擔，亦無政府法令禁止扣押或禁止持有、轉讓或質押之物品；如有任何糾紛概由抵押物提供人自行負責處理，與債權人無關，如因此致債權人遭受損害時，抵押物提供人願負全部賠償責任。</li>
        <li> <span class="tit">七、</span>抵押物提供人占有抵押物應盡善良管理人之注意慎重保管妥善使用，且不得懈怠修理保養等有關保存上之行為。關於擔保物之稅捐、修理、保養及維護等一切費用，概由抵押物提供人負擔。除強制責任險外，抵押物應以債權人為唯一受益人向保險公司投保竊盜及車損險。 </li>
        <li> <span class="tit">八、</span>抵押物提供人非經債權人之書面同意不得擅自將抵押物遷移、出賣、出質、移轉或為其他處分，如擬變更、改良、增設、廢棄等情事亦需先經債權人之書面同意後，始得辦理。</li>
        <li> <span class="tit">九、</span>抵押物之抵押範圍，包括其主物、附屬物、加工物、附合物、混合物、備用物品及工具等與主物有關連之一切物品在內。</li>
        <li> <span class="tit">十、</span>抵押物之現狀發生變動時，不論其因如何，抵押物提供人應即時通知債權人，其因抵押物現狀之變動或價值之貶落致不能或不足使本契約前開所列之全部債權獲得清償時，抵押物提供人應負責提供相當價額之擔保，若有不足應負責補足之，如債權人因此所遭受之損失，抵押物提供人願負完全賠償責任。</li>
      </ul>
      <ul class="ul3">
        <li> <span class="tit">十一、</span>抵押物應按債權人之指定存置於存放處所，抵押物提供人保證絕不擅自遷移，抵押物為交通工具時，經債權人同意得由抵押物提供人或其他第三人使用者，一經債權人通知，抵押物提供人應即在合理期間內負責將抵押物停放於債權人指定處所。</li>
        <li> <span class="tit">十二、</span>債務人、保證人或抵押物提供人同意在未完全清償本借款之全部債務前，債權人有權隨時通知並親至作為本借款擔保之抵押物放置或座落之處所檢視抵押物狀況，並標示、拍照存證，以表彰債權人之權利。</li>
        <li> <span class="tit">十三、</span>債權人對抵押車輛不負瑕疵擔保責任。</li>
        <li> <span class="tit">十四、</span>抵押物如因公徵用、保險事故發生或其他原因，債權人得領取補償款或受領賠償金。</li>
        <li> <span class="tit">十五、</span>債務人發生違約情事，致債權人終止期限利益，視為全部到期時，或抵押物提供人不履行契約，或抵押物被遷移、出賣、出質、移轉或受其他處分，有害於債權人抵押權行使時，債權人得隨時自行或委託第三人占有抵押物，或依動產擔保交易法第十七條第二項後段逕行聲請法院實施強制執行。</li>
        <li> <span class="tit">十六、</span>如債務人、保證人或抵押物提供人在債權人占有抵押物後之十日期間內清償，並負擔占有費用者，得回贖抵押物，但抵押物有敗壞之虞，或其價值顯有減少，足以妨害債權人之權利，或其保管費用過鉅者，得由債權人於占有抵押物後立即依法處理或出賣。</li>
        <li> <span class="tit">十七、</span>債權人因逕行委託專業汽車協尋公司追蹤、占有車輛；因此所產生之費用（含協尋費、拖車費、配鎖費、保管費用等）概由債務人全數負擔，絕無異議，前述取回占有車輛所生之各項費用之收費依債權人與其簽訂之合約規定為主。</li>
        <li> <span class="tit">十八、</span>債權清償方式及利率悉依債權人及債務人雙方間之個別契約約定，合意管轄法院約定台灣台北地方法院。</li>
        <li> <span class="tit">十九、</span>本契約正本壹式肆份，監理單位設定登記完竣後留存一份，雙方各執一份。</li>
      </ul>
      <div class="box1">
        <p class="tit1">立契約書人已於五日以上合理期間內詳閱本契約書各條款之內容，並於簽署前業已完全瞭解及同意。</p>
        <p class="tit2">立契約書人<span class="titall tit6">{{getItem.name}}</span></p>
        <div class="tit7">債務人: <span class="titall tit7">{{getItem.name}}</span><br/><span class="ps">(即抵押物提供人)</span></div><br/>
        <div class="tit8"><span class="tit8-1">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：</span><span class="titall tit8">{{getItem.city}}{{getItem.area}}{{getItem.address}}</span></div>
        <br/>
        <div class="tit9">統一編號：<span class="titall tit9">{{getItem.memberId}}</span></div>
        <div class="date">立約日中華民國<span class="y">{{ getNow.year }}</span>年<span class="m">{{ getNow.month }}</span>月<span class="d">{{ getNow.day }}</span>日</div>
        <ul>
          <li>債權人：裕富數位資融股份有限公司</li>
          <li>代表人：許國興</li>
          <li>地址：新北市新店區中興路三段3號2樓</li>
          <li>統一編號：80659759</li>
        </ul>
      </div><!--box1-->
      <div class="bt-right">109.03版</div>


    </div><!--page2-->
  </div><!--wrapper-->
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'MortgagePrintView',
  data(){
    return {
      item: null,
    }
  },
  created(){
    const profileId = this.$route.query.profileId;
    if (profileId){
      this.fetchMortgageInfo({profileId: profileId}).then(results=>{
        if (results.length){
          this.item = results[0];
          console.log(`fetchMortgageInfo ${JSON.stringify(this.item)}`);
          this.createDate = new Date(this.getItem.createDate);
          console.log(`createDate ${this.createDate}`);
        }
      });
    }
  },
  computed:{
    getNow(){
      const now = new Date();
      return {
        year: now.getFullYear() - 1911,
        month: now.getMonth() + 1,
        day: now.getDate()
      }
    },
    getItem(){
      return this.item;
    },
  },
  methods: {
    ...mapActions(['fetchMortgageInfo',]),
  }
};
</script>

<style scoped src="../../assets/css/mortgage_print.css">

</style>



// WEBPACK FOOTER //
// src/pages/web/MortgagePrintView.vue